import { createFileRoute } from '@tanstack/react-router';
import { DeviceRulesTab } from '@/features/devices/components';

export const Route = createFileRoute('/_app/devices/$deviceId/rules')({
  component: DeviceRulesTab,
});
